export default "<m-label\n    content=\"Hello World!\"\n    font-size=\"80\"\n    alignment=\"center\"\n    y=\"2\"\n    width=\"10\"\n></m-label>\n";